import { render, staticRenderFns } from "./RatingDirectionsRootView.vue?vue&type=template&id=0038065d"
import script from "./RatingDirectionsRootView.vue?vue&type=script&lang=js"
export * from "./RatingDirectionsRootView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports